var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"index-content"},[_c('u-page-back',{attrs:{"title":"中转页"}}),_c('div',{staticClass:"img-wrapper hl-column"},_vm._l((_vm.jumpMiddlePageImageUrls),function(item,index){return _c('img',{key:index,staticClass:"img-infoPic",attrs:{"src":item,"alt":""}})}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }